import React from "react"
import { graphql } from "gatsby"
import { FlexibleContent } from "@jambaree/gatsby-theme-wordpress"

import * as blocks from "../../components/blocks"

const DefaultPageTemplate = props => {
  const {
    data: {
      page: {
        title,
        uri,
        template: {
          acf: { modules },
        },
      },
    },
  } = props
  return (
    <>
      <FlexibleContent blocks={blocks} rows={modules} data={{ title, uri }} />
    </>
  )
}

export default DefaultPageTemplate

export const CollectionQuery = graphql`
  query PageBuilderPage($id: String!) {
    page: wpPage(id: { eq: $id }) {
      title
      slug
      uri
      id

      template {
        ... on WpDefaultTemplate {
          ...DefaultTemplateFragment
        }
      }
    }
  }
`
